import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./CookieBanner.css";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    localStorage.setItem("cookieConsentDate", new Date().toISOString());
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookieConsent", "rejected");
    localStorage.setItem("cookieConsentDate", new Date().toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-content">
        <p>
          Bu web sitesi, deneyiminizi iyileştirmek için yalnızca zorunlu teknik çerezler kullanmaktadır.
          Detaylı bilgi için <Link to="/cerez-politikasi">Çerez Politikası</Link> sayfamızı inceleyebilirsiniz.
        </p>
        <div className="cookie-banner-buttons">
          <button className="cookie-reject-btn" onClick={handleReject}>
            Reddet
          </button>
          <button className="cookie-accept-btn" onClick={handleAccept}>
            Kabul Et
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
